<!--<div class="card md:hidden">-->
<!--    <p-splitter-->
<!--        class="h-full"-->
<!--        [panelSizes]="[15, 85]"-->
<!--        styleClass="mb-5"-->
<!--        layout="vertical">-->
<!--        <ng-template pTemplate>-->
<!--            <div class="col flex justify-content-center">-->
<!--                &lt;!&ndash;                <app-left-content>              </app-left-content>&ndash;&gt;-->
<!--            </div>-->
<!--        </ng-template>-->
<!--        <ng-template pTemplate>-->
<!--            <div class="col flex justify-content-center">-->
<!--                &lt;!&ndash;                <app-right-content></app-right-content>&ndash;&gt;-->
<!--            </div>-->
<!--        </ng-template>-->
<!--    </p-splitter>-->
<!--</div>-->

<div class="mt-4 md:mt-0">
    <p-splitter [style]="{ height: '50 rem'}" [panelSizes]="[20, 80]" [minSizes]="[15, 70]" [layout]="dividerLayout"
                styleClass="col-12 px-0">

        <ng-template pTemplate>
            <!--left-content begin-->
            <div class="pt-5 pr-5 pl-3 w-full">
                <div class="flex justify-content-center">
                    <img src="assets/layout/images/logo-dark.svg" class="w-6">
                </div>
                <div class="mt-5 flex flex-column align-items-center">
                    <div class="flex align-items-center w-10">
                        <i class="pi pi-user text-white bg-black-alpha-70 p-2 font-bold border-round"></i>
                        <span class="font-bold pl-2">Janakan K</span>
                    </div>
                    <div class="mt-4 w-full">
                        <p-accordion [activeIndex]="0">
                            <p-accordionTab header="Task manager">
                                <div (click)="changeCurrentRightContent('kanban')"
                                     class="my-3 flex align-items-center cursor-pointer hover:bg-gray-200 p-2 border-round">
                                    <i
                                        class="pi pi-objects-column text-white bg-black-alpha-70 p-2 font-medium border-round"></i>
                                    <span class="font-bold pl-2">{{ 'task.task-board' | translate }}</span>
                                </div>
                                <div (click)="filterTasksArrData('received')"
                                    class="my-3 flex align-items-center cursor-pointer hover:bg-gray-200 p-2 border-round">
                                    <i
                                        class="pi pi-file-import text-white bg-black-alpha-70 p-2 font-medium border-round"></i>
                                    <span class="font-bold pl-2">{{ 'task.received-tasks' | translate }}</span>
                                </div>
                                <div (click)="filterTasksArrData('sent')"
                                    class="my-3 flex align-items-center cursor-pointer hover:bg-gray-200 p-2 border-round">
                                    <i
                                        class="pi pi-file-export text-white bg-black-alpha-70 p-2 font-medium border-round"></i>
                                    <span class="font-bold pl-2">{{ 'task.sent-tasks' | translate }}</span>
                                </div>
                                <div (click)="filterTasksArrData('backlog')"
                                     class="my-3 flex align-items-center cursor-pointer hover:bg-gray-200 p-2 border-round">
                                    <i class="pi pi-list text-white bg-black-alpha-70 p-2 font-medium border-round"></i>
                                    <span class="font-bold pl-2">{{ 'task.backlog' | translate }}</span>
                                </div>
                            </p-accordionTab>
                        </p-accordion>
                    </div>
                </div>
            </div>
            <!--left-content end-->
        </ng-template>

        <ng-template pTemplate>

            <!--Task-details-sidebar begin-->
            <p-sidebar [(visible)]="taskDetailsSidebarService.isDetailsVisible" (onHide)="getBackScrollbar()"
                       [showCloseIcon]="true" styleClass="w-full md:w-7" position="right">
                <ng-template pTemplate="header">
                    <span class="font-semibold text-xl">{{ taskTitle }}</span>
                </ng-template>
                <app-task-details (taskTitle)="getTaskTitle($event)"></app-task-details>
            </p-sidebar>
            <!--Task-details-sidebar end-->

            <!--kanban component begin-->
            <app-kanban-parent-component *ngIf="currentRightContent === 'kanban'"
                                         class="w-full md:pl-3"></app-kanban-parent-component>
            <!--kanban component end-->

            <!--Task-list-table begin-->
            <p-table *ngIf="currentRightContent === 'default'" [value]="tasks" dataKey="id"
                     [tableStyle]="{ 'min-width': '60rem' }" [expandedRowKeys]="expandedRows"
                     (onRowExpand)="onRowExpand($event)" (onRowCollapse)="onRowCollapse($event)" class="w-full">
                <ng-template pTemplate="header">
                    <tr>
                        <th style="width: 5rem"></th>
                        <th pSortableColumn="no">{{ 'task.task-no' | translate }}
                            <p-sortIcon field="no"/>
                        </th>
                        <th pSortableColumn="title">{{ 'task.title' | translate }}
                            <p-sortIcon field="title"/>
                        </th>
                        <th pSortableColumn="state">{{ 'task.state' | translate }}
                            <p-sortIcon field="state"/>
                        </th>
                        <th pSortableColumn="targetDate">{{ 'task.end' | translate }}
                            <p-sortIcon field="targetDate"/>
                        </th>
                        <th pSortableColumn="recipient">{{ 'task.recipient' | translate }}
                            <p-sortIcon field="recipient"/>
                        </th>
                        <th></th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-task let-expanded="expanded">
                    <tr>
                        <td>
                            <p-button type="button" pRipple [pRowToggler]="task" [text]="true" [rounded]="true"
                                      [plain]="true" [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"/>
                        </td>
                        <td>
                            <div class="flex align-items-center">
                                <app-task-status-icon [status]="task.status"></app-task-status-icon>
                                <span class="pl-3">{{ task.no }}</span>
                            </div>
                        </td>
                        <td>{{ task.title }}</td>
                        <td>{{ task.state }}</td>
                        <td>{{ task.targetDate }}</td>
                        <td>{{ task.recipient }}</td>
                        <td>
                            <i class="pi pi-pencil cursor-pointer" (click)="openDetails()"></i>
                        </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="rowexpansion" let-task>
                    <tr>
                        <td colspan="7">
                            <div class="p-3">
                                <p-table [value]="task.subtasks" dataKey="id">
                                    <ng-template pTemplate="header">
                                        <tr>
                                            <th pSortableColumn="id">Id
                                                <p-sortIcon field="id"/>
                                            </th>
                                            <th pSortableColumn="no">No
                                                <p-sortIcon field="no"/>
                                            </th>
                                            <th pSortableColumn="state">State
                                                <p-sortIcon field="state"/>
                                            </th>
                                            <th pSortableColumn="title">Title
                                                <p-sortIcon field="title"/>
                                            </th>
                                            <th style="width: 4rem"></th>
                                        </tr>
                                    </ng-template>
                                    <ng-template pTemplate="body" let-subtask>
                                        <tr>
                                            <td>{{ subtask.id }}</td>
                                            <td>{{ subtask.no }}</td>
                                            <td>{{ subtask.state }}</td>
                                            <td>{{ subtask.title }}</td>
                                            <td>
                                                <p-button type="button" icon="pi pi-search"/>
                                            </td>
                                        </tr>
                                    </ng-template>
                                    <ng-template pTemplate="emptymessage">
                                        <tr>
                                            <td colspan="6">There are no subtask for this task yet.</td>
                                        </tr>
                                    </ng-template>
                                </p-table>
                            </div>
                        </td>
                    </tr>
                </ng-template>
            </p-table>
            <!--Task-list-table end-->
        </ng-template>

    </p-splitter>
</div>
